import { atom } from "recoil";

export type chatType = {
  visible: boolean;
  cs_id: number | null;
  area_name: string;
  direct_open: boolean;
  chat_id: number | null;
  date: string;
};

export type chatListType = {
  cs_id: number;
  store_id: number;
  order_id: string;
  order_seq: number;
};

export const chatState = atom<chatType>({
  key: "chatState",
  default: {
    visible: false,
    cs_id: null,
    area_name: "",
    direct_open: false,
    chat_id: null,
    date: "",
  },
});

export const chatFinishedState = atom<boolean>({
  key: "chatFinished",
  default: false,
});

export const newChatListState = atom<chatListType[]>({
  key: "newChatList",
  default: [],
});
